import Routing from "./components/Routing";

function App() {
  return (
    <Routing></Routing>
  );
}

export default App;
